export const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    // Convertir en string si ce n'est pas déjà le cas
    const phoneStr = String(phoneNumber);
    // Format: +XX XX XX XX XX
    return phoneStr.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '+$1 $2 $3 $4 $5');
}; 